// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__6CIZA","info":"Pagination_info__c3aJe","list":"Pagination_list__FjVs8"};